var map = {
	"./broadcast.svg": "2c20",
	"./camera.svg": "6be1",
	"./chat.svg": "0d0e",
	"./chatend.svg": "1fee",
	"./close.svg": "1434",
	"./closeBlack.svg": "8453",
	"./emoji.svg": "e7c0",
	"./eval-less.svg": "3686",
	"./eval-normal.svg": "5b91",
	"./eval-satisfied.svg": "3426",
	"./eval-very.svg": "6c43",
	"./eval-worse.svg": "ef28",
	"./evaluateLess.svg": "e172",
	"./evaluateLessActive.svg": "75e9",
	"./evaluateNormal.svg": "3084",
	"./evaluateNormalActive.svg": "c53d",
	"./evaluateSatisfied.svg": "2d1c",
	"./evaluateSatisfiedActive.svg": "318b",
	"./evaluateVery.svg": "3674",
	"./evaluateVeryActive.svg": "5d1b",
	"./evaluateWorse.svg": "11f5",
	"./evaluateWorseActive.svg": "834d",
	"./file.svg": "d178",
	"./fileupload.svg": "8234",
	"./heart.svg": "2f66",
	"./image.svg": "797c",
	"./imager.svg": "d5ff",
	"./keyboard.svg": "3f8c",
	"./leavemsg.svg": "31e8",
	"./modelClose.svg": "220d",
	"./pcvideo.svg": "b4be",
	"./plus.svg": "8f9e",
	"./qq.svg": "0470",
	"./silence.svg": "f7b0",
	"./thumb.svg": "bc02",
	"./video.svg": "23f5",
	"./videoplay.svg": "32d4",
	"./voice.svg": "d104",
	"./wechat.svg": "c49a",
	"./window.svg": "702f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47be";